import axios from 'axios';

const root = '/api/bms/ocr-history';
async function request(config) {
  let response;
  try { response = await axios(config); }
  catch (error) { error.reported = true; throw error; }
  if (config.responseType === 'blob') {
    if ((response.data.type || '').includes('json')) {
      const body = JSON.parse(await response.data.text());
      throw new Error(body.msg || '操作失败');
    }
    return response.data;
  }
  if (response.data.code !== 200) {
    const error = new Error(response.data.msg || '操作失败');
    error.reported = true;
    throw error;
  }
  return response.data.data;
}
export const listOcrHistory = params => request({ url: root, params });
export const getOcrHistory = id => request({ url: `${root}/${id}` });
export const getOcrAudit = id => request({ url: `${root}/${id}/audit` });
export const getOcrImage = id => request({ url: `${root}/${id}/image`, responseType: 'blob' });
export const saveOcrReview = (id, data) => request({ url: `${root}/${id}/review`, method: 'put', data });
export const exportOcrTraining = ids => request({ url: `${root}/export`, method: 'post', data: ids, responseType: 'blob' });
